export function logout(instance, removeFromStorage = true) {
	if (removeFromStorage) {
		localStorage.removeItem("ap-liu");
	}

	const account = instance.getActiveAccount();
	instance.logoutRedirect({ account: account });
}